const mutations = {
  setModels(state, data) {
    state.periodoExamens = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.periodoExamen = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.periodoExamens.unshift(model);
  },

  updateModel(state, model) {
    const index = state.periodoExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.periodoExamens.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.periodoExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.periodoExamens.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
